import styled from 'styled-components';
import { Layout } from 'antd';

const { Sider, Header, Content } = Layout;

export const AppLayoutWrapper = styled(Layout)`
  min-height: 100vh;
  background: var(--bg-main);
  font-family: 'Outfit', 'Inter', sans-serif;
`;

export const GlassSider = styled(Sider)`
  background: rgba(255, 255, 255, 0.8) !important; /* Pure Light Glass */
  backdrop-filter: blur(25px) saturate(200%);
  border-right: 1px solid rgba(0, 0, 0, 0.05);
  margin: 16px;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  
  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    padding: 20px 0;
  }

  .ant-layout-sider-trigger {
    background: rgba(0, 0, 0, 0.02) !important;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    border-radius: 0 0 24px 24px;
    color: var(--text-muted);
    
    &:hover {
      color: var(--waya-red);
      background: rgba(0, 0, 0, 0.04) !important;
    }
  }
`;

export const GlassHeader = styled(Header)`
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid rgba(0, 0, 0, 0.05);
  display: flex !important;
  justify-content: flex-end;
  align-items: center;
  padding: 0 32px !important;
  height: 80px !important;
  margin: 16px 16px 0 0;
  border-radius: 24px;
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 16px;
  z-index: 100;
  width: calc(100% - 32px);
  margin-left: auto;
  transition: all 0.3s ease;
`;

export const MainContent = styled(Content)`
  margin: 24px 16px !important;
  padding: 0 !important;
  background: transparent !important;

  .content-inner {
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(12px);
    border: 1px solid rgba(0, 0, 0, 0.05);
    border-radius: 28px;
    padding: 32px;
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.03);
    min-height: calc(100vh - 160px);
  }
`;

export const LogoContainer = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 24px;
  margin-bottom: 24px;
  
  img {
    height: 44px;
    width: auto;
    filter: drop-shadow(0 4px 12px rgba(231, 71, 44, 0.1));
  }
`;

export const StyledMenu = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 16px;

  .ant-menu {
    background: transparent !important;
    border: none !important;
    
    .ant-menu-item, .ant-menu-submenu-title {
      border-radius: 14px !important;
      margin: 6px 0 !important;
      height: 52px !important;
      line-height: 52px !important;
      color: var(--text-main) !important;
      font-weight: 500;
      font-size: 14px;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

      .anticon, .ant-menu-item-icon {
        font-size: 20px !important;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
      }

      &:hover {
        background: rgba(231, 71, 44, 0.05) !important;
        color: var(--waya-red) !important;
        
        .anticon, .ant-menu-item-icon {
          transform: scale(1.1) rotate(5deg);
          color: var(--waya-red) !important;
        }
      }
    }

    /* Selected State */
    .ant-menu-item-selected {
      background: linear-gradient(135deg, var(--waya-red) 0%, #ff6b52 100%) !important;
      color: #fff !important;
      box-shadow: 0 8px 20px rgba(231, 71, 44, 0.3);
      
      .ant-menu-title-content {
        color: #fff !important;
        font-weight: 600;
      }

      .anticon, .ant-menu-item-icon {
        color: #fff !important;
        transform: scale(1.05);
      }

      &::after {
        display: none !important;
      }
    }

    /* Submenu Open State */
    .ant-menu-submenu-open > .ant-menu-submenu-title {
      color: var(--text-main) !important;
      background: rgba(0, 0, 0, 0.02) !important;
    }

    .ant-menu-sub {
      background: rgba(0, 0, 0, 0.02) !important;
      border-radius: 14px;
      margin: 4px 0 !important;
      padding: 4px 0 !important;
      border: 1px solid rgba(0, 0, 0, 0.02);

      .ant-menu-item {
        height: 44px !important;
        line-height: 44px !important;
        margin: 2px 12px !important;
        font-size: 13px;
        
        &.ant-menu-item-selected {
          background: rgba(231, 71, 44, 0.1) !important;
          color: var(--waya-red) !important;
          box-shadow: none;
          
          .ant-menu-title-content {
            color: var(--waya-red) !important;
          }
        }
      }
    }
  }

  /* Custom Scrollbar */
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 10px;
  }
`;
